<template>
    <div class="PageWrapper" :class="{ 'PageWrapper--contained': contained }">
        <LogoLoader v-if="loading" :class="{'LogoLoader--withHiddenSiblings': nonDestructiveOnLoading}" />
        <template v-else>
            <slot name="header">
                <div v-if="title || description" class="PageWrapper__header">
                    <div class="PageWrapper__headerText flex-1">
                        <div class="PageWrapper__headerTitle">
                            {{ title }}
                        </div>
                        <div class="PageWrapper__headerDescription">
                            {{ description }}
                        </div>
                    </div>
                    <slot name="headerActions" />
                </div>
            </slot>
        </template>

        <template v-if="nonDestructiveOnLoading">
            <div v-show="!loading" class="PageWrapper__nonDestructiveContainer">
                <slot />
            </div>
        </template>
        <template v-else>
            <slot v-if="!loading" />
        </template>
    </div>
</template>

<style lang="scss">
$main-layout-spacing: 16px;

.PageWrapper {
    height: 100%;
    position: relative;
    padding: $main-layout-spacing;
    overflow: auto;
    flex: 1 0;
    display: flex;
    flex-direction: column;

    /* The page scrolls inside its own regions, so the wrapper itself must not. */
    &--contained {
        overflow: hidden;
    }

    &__header {
        padding: $main-layout-spacing 0;
        // margin bottom due to pageWrapper padding, this balances out and makes header above and below equal sapce
        margin-bottom: $main-layout-spacing;
        display: flex;
        justify-content: space-between;
        align-items: flex-start;
        gap: $main-layout-spacing;

        @media (max-width: 640px) {
            flex-direction: column;
        }
    }

    &__headerTitle {
        font-size: 24px;
        font-weight: 500;
    }

    &__headerDescription {
        font-size: 16px;
        color: var(--eidSecureBlue-75);
        font-weight: 400;
    }

    &__nonDestructiveContainer {
        height: 100%;
    }

    &__toolbar {
        display: flex;
        align-items: center;
        margin: 0 0 $main-layout-spacing;
    }

    &__toolbarContent {
        flex: 1;
    }

    &__toolbarContentEnd {
        margin-left: auto;
    }

    > .LogoLoader:only-child, > .LogoLoader--withHiddenSiblings {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        font-size: 0.7em;
    }

    > .ScreenMessage:only-child {
        position: relative;

        &:before {
            display: none;
        }
    }
}
</style>

<script lang="ts">
    import { defineComponent } from 'vue';

    import { LogoLoader } from '@evidentid/dashboard-commons/components/LogoLoader';

    export default defineComponent({
        name: 'PageWrapper',
        components: {
            LogoLoader,
        },
        props: {
            title: {
                type: String,
                default: '',
            },
            description: {
                type: String,
                default: '',
            },
            nonDestructiveOnLoading: {
                type: Boolean,
                default: false,
            },
            loading: {
                type: Boolean,
                default: false,
            },
            contained: {
                type: Boolean,
                default: false,
            },
        },
    });
</script>
